export const NavMenuItem = {
  advisors: 'Advisors',
  articles: 'Articles',
  horoscope: 'Horoscope',
  accountInformation: 'Account Information'
};

export const advisorsMenuItems: NavigationItem[] = [
  {
    name: 'Psychic Readings',
    href: '/psychic-readings/195',
    isTrackEvent: true
  },
  {
    name: 'Love & Relationships',
    href: '/psychic-readings/love-relationships/635',
    isTrackEvent: true
  },
  {
    name: 'Life Path & Advice',
    href: '/psychic-readings/life-path-advice/636',
    isTrackEvent: true
  },
  {
    name: 'Psychic Mediums',
    href: '/psychic-readings/psychic-mediums/754',
    isTrackEvent: true
  },
  {
    name: 'Spiritual Readings',
    href: '/psychic-readings/spiritual-readings/200',
    isTrackEvent: true
  },
  {
    name: 'Tarot Card Readings',
    href: '/psychic-readings/tarot-card-readings/588',
    isTrackEvent: true
  },
  {
    name: 'Astrology Readings',
    href: '/psychic-readings/astrology-readings/196',
    isTrackEvent: true
  },
  {
    name: 'Dream Interpretation',
    href: '/psychic-readings/dream-interpretation/589',
    isTrackEvent: true
  },
  {
    name: 'Financial Guidance',
    href: '/psychic-readings/financial-guidance/705',
    isTrackEvent: true
  },
  {
    name: 'Cartomancy Readings',
    href: '/psychic-readings/cartomancy-readings',
    isTrackEvent: true
  },
  {
    name: 'Angel Readings',
    href: '/psychic-readings/angel-readings',
    isTrackEvent: true
  },
  {
    name: 'Aura Cleansing',
    href: '/psychic-readings/aura-cleansing',
    isTrackEvent: true
  },
  {
    name: 'All Categories',
    href: '/all-categories',
    isTrackEvent: true
  }
];

export const consumerAccountInformationMenuItems: NavigationItem[] = [
  {
    name: 'Payment Information',
    href: '/myaccount/payment-info'
  },
  {
    name: 'Personal Information',
    href: '/MyAccount/UpdatePersonalInfoStarter.aspx'
  },
  {
    name: 'Transaction Details',
    href: '/myaccount/payment-info/transaction-details'
  },
  {
    name: 'Chat Transcripts',
    href: '/ChatTranscripts/Summary'
  },
  {
    name: 'Favourite Advisors',
    href: '/MyAccount/MyFavoriteAdvisors'
  }
];

export const advisorAccountInformationMenuItems: NavigationItem[] = [
  {
    name: 'Payment Information',
    href: '/myaccount/payment-info'
  },
  {
    name: 'Personal Information',
    href: '/MyAccount/UpdatePersonalInfoStarter.aspx'
  },
  {
    name: 'Transaction Details',
    href: '/myaccount/payment-info/transaction-details'
  },
  {
    name: 'My Customers',
    href: '/app/#/myaccount/customers'
  },
  {
    name: 'My Feedback',
    href: '/app/#/myaccount/feedback'
  },
  {
    name: 'My Listings',
    href: '/account/account.asp'
  }
];

export const articlesMenuItems: NavigationItem[] = [
  {
    name: 'All Articles',
    href: '/articles'
  },
  {
    name: 'Love Advice',
    href: '/articles/love'
  },
  {
    name: 'Psychic Advice',
    href: '/articles/psychic'
  },
  {
    name: 'Tarot Advice',
    href: '/articles/tarot'
  },
  {
    name: 'Spiritual Advice',
    href: '/articles/spiritual'
  },
  {
    name: 'Astrology Advice',
    href: '/articles/astrology'
  },
  {
    name: 'Readings 101',
    href: '/psychic-advice',
    isDesktopOnly: true
  },
  {
    name: 'Keen Blog',
    href: '/articles/keen-blog'
  }
];

export const horoscopeMenuItems: NavigationItem[] = [
  {
    name: 'All Horoscopes',
    href: '/horoscope'
  },
  {
    name: 'Aries',
    href: '/horoscope/aries'
  },
  {
    name: 'Taurus',
    href: '/horoscope/taurus'
  },
  {
    name: 'Gemini',
    href: '/horoscope/gemini'
  },
  {
    name: 'Cancer',
    href: '/horoscope/cancer'
  },
  {
    name: 'Leo',
    href: '/horoscope/leo'
  },
  {
    name: 'Virgo',
    href: '/horoscope/virgo'
  },
  {
    name: 'Libra',
    href: '/horoscope/libra'
  },
  {
    name: 'Scorpio',
    href: '/horoscope/scorpio'
  },
  {
    name: 'Sagittarius',
    href: '/horoscope/sagittarius'
  },
  {
    name: 'Capricorn',
    href: '/horoscope/capricorn'
  },
  {
    name: 'Aquarius',
    href: '/horoscope/aquarius'
  },
  {
    name: 'Pisces',
    href: '/horoscope/pisces'
  }
];

export const advisorMenuData: MainMenuItem = {
  name: NavMenuItem.advisors,
  links: advisorsMenuItems
};

export const articlesMenuData: MainMenuItem = {
  name: NavMenuItem.articles,
  links: articlesMenuItems
};

export const horoscopeMenuData: MainMenuItem = {
  name: NavMenuItem.horoscope,
  links: horoscopeMenuItems
};

export const advisorAccountInformationMenuData: MainMenuItem = {
  name: NavMenuItem.accountInformation,
  links: advisorAccountInformationMenuItems
};

export const consumerAccountInformationMenuData: MainMenuItem = {
  name: NavMenuItem.accountInformation,
  links: consumerAccountInformationMenuItems
};
